import type { SvgIconComponent } from '@mui/icons-material';
import {
  Dashboard as DashboardIcon,
  Key as KeyIcon,
  Devices as DevicesIcon,
  People as PeopleIcon,
  History as LogsIcon,
  Psychology as SkillsIcon,
} from '@mui/icons-material';
import { APP_ROUTES } from '@/constants/routes';

export interface NavigationItem {
  textKey: string;
  path: string;
  icon: SvgIconComponent;
}

/**
 * Sidebar navigation config.
 * Keep this data-only so layout rendering stays simple.
 */
export const NAVIGATION_ITEMS: NavigationItem[] = [
  { textKey: 'nav.dashboard', path: APP_ROUTES.home, icon: DashboardIcon },
  { textKey: 'nav.licenses', path: APP_ROUTES.licenses, icon: KeyIcon },
  { textKey: 'nav.devices', path: APP_ROUTES.devices, icon: DevicesIcon },
  { textKey: 'nav.logs', path: APP_ROUTES.logs, icon: LogsIcon },
  { textKey: 'nav.users', path: APP_ROUTES.users, icon: PeopleIcon },
  { textKey: 'nav.skills', path: APP_ROUTES.skills, icon: SkillsIcon },
];

export const isPathActive = (currentPath: string, targetPath: string): boolean => {
  if (targetPath === APP_ROUTES.home) {
    return currentPath === APP_ROUTES.home;
  }
  return currentPath.startsWith(targetPath);
};

